import { useMovFormaPagamentoListar } from "../../../../../../Services/Financeiro/Conta/Movimentacao/MovFormaPagamentoService";
import { ISelectComPesquisaProps, SelectComPesquisa } from "../../../../../SelectComPesquisa";

interface IMocFormaPagamentoSelect extends ISelectComPesquisaProps {

}
export default function MovFormaPagamentoSelect({
    loading,
    placeholder,
    allowClear,
    ...rest
}:IMocFormaPagamentoSelect) {
    placeholder = placeholder ?? "Selecione";
    allowClear = allowClear ?? true;
    loading = loading ?? false;

    const {
        data,
        isLoading
    } = useMovFormaPagamentoListar({
        ativo : true
    });

    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder}
        allowClear={allowClear}
        loading={isLoading || loading}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    />
}